export default __webpack_public_path__ + "static/media/maxine_detail8.a17d7a92.jpg";